import { cn } from '@/lib/utils';

// The Mesterplan mark: an "MP" monogram whose P stem is a carpenter's pencil.
// Masters and palette: docs/products/mesterplan/brand/README.md

interface BrandMarkProps {
  /** `tile` draws the blue rounded square; `mark` draws only the glyph in currentColor. */
  variant?: 'tile' | 'mark';
  className?: string;
}

export function BrandMark({ variant = 'tile', className }: BrandMarkProps) {
  const glyph = variant === 'tile' ? '#FFFFFF' : 'currentColor';
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
      {variant === 'tile' && <rect width="100" height="100" rx="22" fill="#5D87FF" />}
      <g transform="translate(2 0)">
        <g fill="none" stroke={glyph} strokeWidth="9" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 72 V30 L33 51 L50 30 V72" />
          <path d="M66 30 H70 A12 12 0 0 1 70 54 H66" />
        </g>
        {/* pencil body and sharpened tip, split by a gap that shows the background */}
        <path d="M59.5 26 H67.5 A2 2 0 0 1 69.5 28 V64.2 H57.5 V28 A2 2 0 0 1 59.5 26 Z" fill={glyph} />
        <path d="M57.5 65.8 H69.5 L63.5 80 Z" fill={glyph} />
        <path d="M61.5 75 L63.5 80 L65.5 75 Z" fill="#2A3547" />
      </g>
    </svg>
  );
}

interface BrandLogoProps {
  className?: string;
  markClassName?: string;
  textClassName?: string;
}

/** Tile mark plus the "MesterPlan" wordmark in Manrope. */
export function BrandLogo({ className, markClassName, textClassName }: BrandLogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <BrandMark className={cn('h-9 w-9 shrink-0', markClassName)} />
      <span className={cn('font-brand font-extrabold tracking-tight text-dark dark:text-dark-text', textClassName)}>
        MesterPlan
      </span>
    </span>
  );
}
